import { useEffect, useRef, useState } from "react";

// const SmartEditor = ({width = "100%", height = "500px", getEditorCont, editorCont = "", iframeId = "smartEditor_iframe_container"}) => {
const SmartEditor = ({width = "100%", height = "500px", editorCont = "", iframeId = "smartEditor_iframe_container"}) => {

	const iframeContainer = useRef(null);
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		iframeContainer.current.onload = function() {
			// textarea로 크기 조절을 하는데 에디터의 입력 영역 크기가 같아짐.
			// 위아래 붙는 애들이 53px쯤 됨.
			// 그거 빼고 크기 설정을 해야 원하는 크기로 생성.
			const taHeight = (Number(height.replace("px", "")) - 53) + "px";
			iframeContainer.current.contentWindow.initSmartEditor(width, taHeight, "", heightChange, heightChanging, onLoaded);
		}
	}, []);

	const onLoaded = () => {
		setIsLoaded(true);
	}

	useEffect(() => {
		if(isLoaded) {
			iframeContainer.current.contentWindow.setContent(editorCont);
		}
	}, [editorCont, isLoaded]);

	// 정확한 이유는 모르겠지만, 스마트에디터 사용시 부모에 값을 바로 넘겨주면 다른 useState값을 제대로 불러오지 못함.
	// 값을 useState변수에 세팅해주고 변경시 전달하는 방식으로 처리 하니 정상 동작.
	// const [cont, setCont] = useState(editorCont);

	/*
	// 에디터 내용 변경시
	const changeCont = (data) => {
		// getEditorCont && getEditorCont(data); => 여기서 하면 부모에서 값을 받지만, 다른 useState 사용하는 데이터가 없는 것처럼 처리됨.
		setCont(data);
	};
	*/

	const heightChange = (height) => {
		// 높이 조절 완료 시

		iframeContainer.current.style.height = height;

		// body의 minHeight를 제거하면 화면이 튀듯이 스크롤이 움직임.
		// duration은 0px까지 되는데 걸리는 시간이므로 실제로는 훨씬 짧음. 그래서 1초로 길게 설정. 실제로는 1초 아님.
		// 0.3초뒤에 duration이 제거되므로 그때까지 완료 안되면 탁 튐.
		document.body.style.transitionDuration = "1s";
		document.body.style.minHeight = "0px";
		setTimeout(function() {
			document.body.style.transitionDuration = "0s";
		}, 300);
	};
	const heightChanging = (height) => {
		// 높이 조절 중
		// document.body.style.minHeight = "9999999px";
		// 변경된 크기에 맞춰서 container (iframe) 크기 조절
		iframeContainer.current.style.height = height;
		if(iframeContainer.current.style.height.replace("px", "") * 1 < height.replace("px", "") *1) {
			// 원래보다 커지는 경우에는 따로 뭐 안함.
		} else {
			// 원래보다 작아지는 경우 body 스크롤이 최하단이 되면 그 이후로 빠르게.. 튀듯이 작아짐.
			// 현재크기를 minHeight로 설정해서 스크롤이 최하단이 되지 않도록..
			document.body.style.minHeight = document.body.scrollHeight + "px";
		}
	}

	// useEffect(() => {
	// 	getEditorCont && getEditorCont(cont);
	// }, [cont]);
	
    return (
		// <div id="container" className="iframeContainer" style={{width: width, height: height}}>
		<div id="container" className="iframeContainer" >
			<iframe
				title={iframeId}
				id={iframeId}
				name={iframeId}
				ref={iframeContainer}
				allowFullScreen={true}
				// width={width}
				// height={height}
				style={{width: width, height: height}}
				src={process.env.PUBLIC_URL + "/smarteditor/write.html"}
			></iframe>
		</div>
    );
};

export default SmartEditor;